import { render } from "./UserStatus.vue?vue&type=template&id=3c1916f0&ts=true"
import script from "./UserStatus.vue?vue&type=script&lang=ts"
export * from "./UserStatus.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__